import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import Tween, { Easing } from "tweenkle";
import { IndicatorContainer, Container } from "./loop-indicator.styles";
export const LoopIndicator = ({ activeSlide, indicatorWidth, swiper, slidesCount, show, }) => {
    const [value, setValue] = useState(0);
    const slideWidth = 100 / (slidesCount - 1);
    useEffect(() => {
        const end = activeSlide * slideWidth;
        const tween = new Tween({
            start: Math.abs(value),
            end,
            duration: value === 100 ? 0 : 500,
            ease: Easing.Quad.InOut,
        });
        tween.on("tick", ({ value: tickValue }) => {
            setValue(tickValue);
        });
        tween.start();
    }, [activeSlide]);
    return (_jsx(Container, Object.assign({ show: show, width: indicatorWidth, "data-testid": "carousel-indicator" }, { children: _jsx(IndicatorContainer, { children: _jsx("input", { className: "slider", onInput: (e) => {
                    const newValue = Number(e.currentTarget.value);
                    if (swiper)
                        swiper.slideToLoop(Math.ceil(newValue / slideWidth), 250);
                }, type: "range", min: 0, step: 1, value: value }) }) })));
};
